/* action type */
import type { Action } from '../../store/state/state-manager';

export const NAVIGATE_TO_STEP = 'NAVIGATE_TO_STEP';

/* action creator */
export const navigateToStepAction = (actionPayload: Action['payload']) => {
  return {
    type: NAVIGATE_TO_STEP,
    payload: actionPayload
  };
};
